import React from 'react';

import { VideosPageComponent } from '@bingads-webui-campaign-react/ads-studio-app-components';

export const VideosPage = props => (
  <VideosPageComponent {...props} />
);
